import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import Image from './../../Image'
import bemClass from './../../../utils/bemClass'
import prettyText from './../../../utils/prettyText'

import './Thumbnails.css'

const cn = bemClass('Thumbnails')

class Item extends PureComponent {
    render() {
        const { className, title, date, hour, image, url, archive } = this.props

        return (
            <div className={`${cn('item')} ${className}`}>
                <Link to={url}>
                    <Image
                        src={image}
                        containerClassName={cn('image-container', { archive })}
                        className={cn('image')}
                        alt={title}
                        width={260}
                        height={260}
                    />
                    <div
                        className={cn('title')}
                        dangerouslySetInnerHTML={prettyText(title)}
                    />
                    <div className={cn('date')}>
                        {date}, {hour}
                    </div>
                </Link>
            </div>
        )
    }
}

Item.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
    date: PropTypes.string,
    hour: PropTypes.string,
    image: PropTypes.string,
    url: PropTypes.string,
    archive: PropTypes.bool,
}

Item.defaultProps = {
    className: '',
    title: '',
    date: '',
    hour: '',
    image: null,
    url: '/',
    archive: false,
}

export default Item



// WEBPACK FOOTER //
// ./src/components/FrontPage/Thumbnails/Item.jsx